export default __webpack_public_path__ + "static/media/HOTEL_TEXT.712e51f0.png";